import React, { useEffect, useState } from "react";
import API from "../api/axiosInstance";
import "../styles/RelatedRecordsPopup.css";

type RelatedRecordsPopupProps = {
    record: any;
    onClose: () => void;
};

const RelatedRecordsPopup: React.FC<RelatedRecordsPopupProps> = ({ record, onClose }) => {
    const [relatedRecords, setRelatedRecords] = useState<any[]>([]);

    useEffect(() => {
        fetchRelatedRecords();
    }, []);

    const fetchRelatedRecords = async () => {
        try {
            const response = await API.get(`/records/${record.id}/related`);
            setRelatedRecords(response.data);
        } catch (error) {
            console.error("Error fetching related records:", error);
        }
    };

    return (
        <div className="popup">
            <h3>Related Records</h3>
            <button onClick={onClose}>Close</button>
            <ul>
                {relatedRecords.map((rel) => (
                    <li key={rel.id}>{rel.name}</li>
                ))}
            </ul>
        </div>
    );
};

export default RelatedRecordsPopup;
